/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
// polyfill for RegExp.escape
export const dig = (o, steps, def) => {
    const x = steps
        .split('.')
        .reduce((r, e) => (r ? r[e === '0' ? 0 : e] : r), o);
    return typeof x === 'undefined' ? def : x;
};

// eslint-disable-next-line no-underscore-dangle
const _def = (x, def) => (x == null ? def : x);
// eslint-disable-next-line no-underscore-dangle
const _digger = (steps, def) => o => _def(steps.reduce((r, e) => (r ? r[e] : r), o), def);

export const gettr = (path, def) => _digger(path.split('.'), def);

if (!RegExp.escape) {
    RegExp.escape = s => String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
}
// polyfill for date.getDaysInMonth()
// TODO remove it
// eslint-disable-next-line no-extend-native,func-names
Date.prototype.getDaysInMonth = function() {
    return 33 - new Date(this.getFullYear(), this.getMonth(), 33).getDate();
};

// polyfill for Object.hasData()
// eslint-disable-next-line func-names
Object.hasData = function(obj, path) {
    if (path) {
        const data = dig(obj, path, '');
        return !!data;
    }
    return obj && Object.keys(obj).length > 0;
};

// polyfill for Array.hasData()
// eslint-disable-next-line func-names
Array.hasData = function(arr) {
    // TODO seems wrong!
    return arr && Object.keys(arr).length > 0;
};
